import { render } from "./videoItem.vue?vue&type=template&id=8abafea0&scoped=true"
import script from "./videoItem.vue?vue&type=script&lang=js"
export * from "./videoItem.vue?vue&type=script&lang=js"

import "./videoItem.vue?vue&type=style&index=0&id=8abafea0&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8abafea0"]])

export default __exports__